<template>
  <div class="helperMenu">
    <button @click="showModal('AddPromotionModal')">
      <PlusIcon />
      <div class="new-btn-label">Nowa promocja</div>
    </button>
  </div>
</template>

<script>
import PlusIcon from '@/components/svgs/icons/PlusIcon.vue';

export default {
  name: "PromotionsHelperMenu",
  components: {
    PlusIcon
  },
  data() {
    return {
      content: ""
    };
  },
  methods: {
    showModal(componentName) {
      this.$store.commit("showModal", componentName);
    }
  }
};
</script>

<style lang="scss" scoped>
button {
  display: flex;
  align-items: center;
  margin: 10px;

  svg {
    width: 20px;
    margin-right: 10px;
    margin-left: -10px;
    fill: #fff;
  }
}

.plus-icon {
  flex-grow: 1;
  margin: 3px 0;
  margin-right: 8px;
}

.new-btn-label {
  flex-grow: 8;
  font-weight: bold;
  font-size: 16px;
}

</style>
